import { color, size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Icon } from "../../Icon";
export const CheckMarkIcon = styled(Icon) `
  position: relative;

  &.unchecked {
    &:before {
      content: "";
      border: ${size.border.base.hairline} solid
        ${color.border.selectableBox.default};
      position: absolute;
      box-sizing: border-box;
      display: block;
      width: 74%;
      height: 74%;
      top: 13%;
      left: 13%;
    }

    path {
      visibility: hidden;
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hlY2tNYXJrSWNvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NoZWNrTWFyay9zdHlsZWQvQ2hlY2tNYXJrSWNvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUM3RSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBRWxDLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUE7Ozs7OztnQkFNekIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsUUFBUTtVQUMvQixLQUFLLENBQUMsTUFBTSxDQUFDLGFBQWEsQ0FBQyxPQUFPOzs7Ozs7Ozs7Ozs7OztDQWMzQyxDQUFDIn0=